import { useState } from 'react';
import Slider from 'react-input-slider';

import './App.css';

function App() {
  const [ skew, setSkewXY ] = useState({ x: 0, y: 0});
  const [ scale, setScaleXY ] = useState({ x: 1, y: 1});

  const transform = `scale(${scale.x} ${scale.y}) skewX(${skew.x}) skewY(${skew.y})`;

  return (
    <div className="App">
      <header className="App-header">
        <h1>SVG Text transformation Tool</h1>
      </header>
      <main className='container'>
        <div className='row'>
          <div className='col-md-6 text-center'>
            <h1>Skew</h1>
            <p>({skew.x}, {skew.y}): <Slider axis="xy" x={skew.x} y={skew.y} xmin={-45} xmax={45} ymin={-45} ymax={45} onChange={({ x, y }) => setSkewXY({x, y})} /></p>
          </div>
          <div className='col-md-6 center'>
            <h1>Scale</h1>
            <p>({scale.x}, {scale.y}): <Slider axis="xy" x={scale.x} y={scale.y} xstep={0.01} ystep={0.01} xmin={0} ymin={0} xmax={4} ymax={4} onChange={({ x, y }) => setScaleXY({x, y})} /></p>
          </div>
        </div>
        <hr/>
        <div className='row'>
          <svg width='100%' height='600' viewbox="0 0 1000 1000">
            <text x={300} y={200} fontSize={50} transform={transform}>Hello World</text>
          </svg>
        </div>
      </main>
    </div>
  );
}

export default App;
